import React from "react";
import './RezervacijeDan.css';
export default class RezervacijeDan extends React.Component {

weekDayName = (dayNum) =>{
switch(dayNum) {
    case 0:
        return 'Ponedeljak'
    case 1:
        return 'Utorak'
            case 2:
        return 'Sreda'
            case 3:
        return 'Četvrtak'
            case 4:
        return 'Petak'
            case 5:
        return 'Subota'
            case 6:
        return 'Nedelja'
    default:
       return ''
}
}

	render() {
    let Rezervacije = [];
       Rezervacije.push(<div key={"main div"}
              style={{
                marginTop:0,
                padding: 3,
                background: "#a47655",
                display: "flex",
                flexDirection: "column",
                borderRadius: 5,
              }}
            >
      <em style={{ color: "white", textAlign: "center", fontWeight: "bold" }}>
        {this.weekDayName(this.props.rezervacije[0]["dan"])} {this.props.rezervacije[0]["RezervisanDatum"].substr(0, 10)}
      </em></div>
    );

    for (let i = 0; i < this.props.rezervacije.length; i++) {
        Rezervacije.push(
          <div key={i} style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                margin: 2,
                padding: 3,
                background: "#c4a685",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <em style={{ color: "#7f4838", fontWeight: "bold" }}>
                {this.props.rezervacije[i]["Naziv"].split("/")[0]}
              </em>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <em>
                  Smena I:{this.props.rezervacije[i]["s1"]} Smena II:{
                    this.props.rezervacije[i]["s2"]
                  }{" "}
                  Smena III:{this.props.rezervacije[i]["s3"]}
                </em>
                <em
                  style={{
                    color: "Brown",
                    fontWeight: "bold",
                    marginLeft: "auto",
                    marginRight: 10
                  }}
                >
                  {this.props.rezervacije[i]["ukupno"]}
                </em>
              </div>
            </div>
          </div>
          );   
      }

		return (

      <div className= "rezervacijeDan" style={{  borderRadius: 5,
          WebkitFlex: '430px',
          marginTop: 0,
          marginBottom: 8,
          marginRight:5,
          padding: 5,
          fontFamily: "Raleway,sans-serif",
          textAlign: "left",
          background: "rgb(232, 232, 232)",
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "14px",
          display: "flex",
          flexDirection: "column"}}>
        {Rezervacije}          
        </div>
        );
      
    
	}
}



// WEBPACK FOOTER //
// ./src/Moduli/RezervacijeDan.js